import { sendPost } from './common';

export async function getLawsuitLinkParam(params: { lawsuit_id: number }) {
	return sendPost<string>('/api/get_lawsuit_detail_link_param/', params);
}
